/* eslint-disable */
import axios from 'axios'
import { sanitize } from '@/js/utils/sanitize'
import { randomBaseUrl } from '@/js/utils/randomBaseUrl'

export const resetPassword = (params, i18n) => new Promise ((resolve, reject) => {

  const currentLanguage = i18n.locale

  let options = params.options ? sanitize(params.options) : 'json'
  let loginName = params.loginName ? sanitize(params.loginName) : null
  let email = params.email ? sanitize(params.email) : null

  options = options ? encodeURIComponent(options) : 'json'
  loginName = loginName ? encodeURIComponent(loginName) : null
  email = email ? encodeURIComponent(email) : null

  let uri = `?options=${options}`
  uri = loginName &&
        loginName !== null &&
        loginName !== 'null' ? `${uri}&login=${params.loginName}` : uri // if loginName add it to uri
  uri = email &&
        email !== null &&
        email !== 'null' ? `${uri}&email=${params.email}` : uri // if email add it to uri

  let alert = false
  let alertType = 'error'
  let alertMessage = i18n.messages[currentLanguage]['lostpassword-screen']['alertMsg']['oops']

  axios.get(randomBaseUrl(0, 3) + process.env.VUE_APP_FORGOT_PASSWORD_ENDPOINT + uri)
    .then(response => {
      const status = response.data.status
      const subject = response.data.message

      if (status === 'error') {

        switch(subject) {
          case "Can't find matching account":
            alertType = 'error'
            alertMessage = i18n.messages[currentLanguage]['lostpassword-screen']['alertMsg']['no-match']
            break

          case 'You must be logged in to perform operation.':
            alertType = 'error'
            alertMessage = i18n.messages[currentLanguage]['lostpassword-screen']['alertMsg']['oops']
            break

          case "Multiple results found":
            alertType = 'success'
            if (params.options == 'json+check') {
              alertMessage = i18n.messages[currentLanguage]['lostpassword-screen']['alertMsg']['success-check']

            } else {
              alertMessage = i18n.messages[currentLanguage]['lostpassword-screen']['alertMsg']['mutiple-account']
            }
            break

          default:
            alertType = 'error'
            alertMessage = i18n.messages[currentLanguage]['lostpassword-screen']['alertMsg']['no-match']
            break
        }

        alert = true // show alert

      } else if (status === 'ok') {
        if (params.options == 'json+check') {
          alert = true
          alertType = 'success'
          alertMessage = i18n.messages[currentLanguage]['lostpassword-screen']['alertMsg']['success-check']

        } else {
          alert = true
          alertType = 'success'
          alertMessage = i18n.messages[currentLanguage]['lostpassword-screen']['alertMsg']['success']
        }

      } else {
        // normaly impossible case with no error but no correct response
        alertType = 'error'
        alertMessage = i18n.messages[currentLanguage]['lostpassword-screen']['alertMsg']['oops']
        alert = true // show alert box

      }

      resolve({
        alert: alert,
        alertType: alertType,
        alertMessage: alertMessage
      })
    })
    .catch(() => {
      // normaly impossible case with no error but no correct response
      alertType = 'error'
      alertMessage = i18n.messages[currentLanguage]['lostpassword-screen']['alertMsg']['oops']
      alert = true // show alert box

      reject({
        alert: alert,
        alertType: alertType,
        alertMessage: alertMessage
      })
    })
})
